export default __webpack_public_path__ + "static/media/Shadow's Gloves of the Burning Temple.f01b1346.jpg";